import React from 'react'
import { DateTime } from 'luxon'
import brotliDecompress from 'brotli/decompress';
import zlib from 'zlib'
import { promisify } from 'util'

import { apiCall, secondaryApi } from './ApiUtils'
import { capitalize, formatDuration, formatAverage, formatPercent, iconDictionaryByMed, socialChannels } from './common'
import { store } from '../store'

const gunzip = promisify(zlib.gunzip)

let sumByLastIndex = (arr) => {
    let index = {}
    for (let i=0; i<arr.length; i++) {
        let row = arr[i], key = row[row.length-1]
        // TODO josh: row[-2] is the date of the row and shouldn't be calculated
        let data = row.slice(0, row.length-1).map(x=>+x)
        index[key] = index[key]||[]
        data.forEach((x, i)=>index[key][i] = (index[key][i]||0)+x)
    }
    return Object.keys(index).map(key => [key, index[key]])
}

let sumArrays = arr => {
    if (!arr.length)
        return arr
    let ans = arr[0].slice(0)
    for (let i=1; i<arr.length; i++) {
        arr[i].forEach((el, j) => ans[j] += el)
    }
    return ans
}

export const getPageSpeedMetrics = async(dataPath, signal=null) => {
    // let answer
    // if (answer = sessionStorage.getItem(`pageMetrics-${dataPath}`)) {
    //     answer = JSON.parse(lzString.decompressFromUTF16(answer))
    //     if (answer.ts && Date.now()-answer.ts < 3600*1000) {
    //         return Promise.resolve({
    //             response: answer,
    //             error: false
    //         })
    //     }
    // }

    const res = await apiCall(`metrics/${dataPath}/pagespeed`, {
        method: 'GET'
    }, false, secondaryApi, signal)

    if(res.response){
        const result = await Promise.all(res.response.result.map(async(item) => {
            if(item.metrics?.type === "Buffer"){
                let pageBinary = await gunzip(Buffer.from(item.metrics.data))
                let pageConv = JSON.parse(pageBinary)
                
                return {
                    ...item,
                    metrics: pageConv
                }
            } else {   
                return {
                    ...item
                }
            }
        }))


        return {
            response: {result}
        }
        //     try {
        //         sessionStorage.setItem(`pageMetrics-${dataPath}`, lzString.compressToUTF16(JSON.stringify(answer)))
        //     } catch(e){
        //         console.error(e)
        //     }
    }

    return {
        ...res
    }
}

export const getPageSpeedMetricsBaseline = async(siteId) => {

    const res = await apiCall(`metrics/${siteId}/pagespeed/baseline`, {
        method: 'GET'
    }, false, secondaryApi, null)

    if(res.response){
        if(res.response.result?.metrics?.type === "Buffer"){
            let pageBinary = await gunzip(Buffer.from(res.response.result?.metrics.data))
            let pageConv = JSON.parse(pageBinary)
            
            return {
                response: {
                    ...res.response.result,
                    metrics: pageConv
                }
            }
        } else {   
            return {
                response: {
                    ...res.response.result,
                }
            }
        }
    }

    return {
        ...res
    }
}

export const ga4HeaderAsArray = (values) => values.reduce((prev, curr) => {
    prev.push(curr.value)
    return prev
}, [])

export const metricCheckByService = (metric) => ({
    fb: metric.fb === undefined,
    ga: metric.ga === undefined || (metric.ga && (metric.ga.reports === undefined || metric.ga.reports.length === 0)),
    gmb: !metric.gmb,
    fbPage: !metric.fbPage,
    linkedin: !metric.linkedin,
    igFollowers: !metric.igFollowers,
    linkedinOrg: !metric.linkedinOrg,
    linkedinOrgLt: !metric.linkedinOrgLt || !metric.linkedinOrgLt?.followerLifetime || metric.linkedinOrgLt?.followerLifetime === 0,
    bing: metric.bing === undefined
})

export const getMetrics = (key, nocache=true, returnAll, signal) => {
    let answer
    // if (!nocache && (answer = sessionStorage.getItem(key))) {
    //     answer = JSON.parse(lzString.decompressFromUTF16(answer))
    //     if (answer.ts && Date.now()-answer.ts < 3600*1000) {
    //         return new Promise((resolve, reject) => resolve(answer.data))
    //     }
    // }

    const options = {
        method: 'GET',
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem("token")
        }
    }

    return apiCall(`/metrics/${key}`, options, null, secondaryApi, signal)
    .then(({response, error}) => {

        if(error){
            throw error
        }
        let answer = {data: response ? response.result : {}, dataByMonth: response ? response.resultMonth : {} ,ts: Date.now()}
        if (!nocache) {
            const state = store.getState()
            const { model } = state?.site

            if(model?.sites?.length > 0 && model.siteActiveIdx >= 0){
                const site = model.sites[model.siteActiveIdx]
                const accts = Object.keys(site?.attr?.accounts)

                const metric = response?.result?.length > 0 ? metricCheckByService(response.result[0]) : {}
                
                const storeInStorage = accts.reduce((prev, curr) => {
                    if(!response || !response?.result){
                        prev = false
                    } else {
                        if(metric[curr]){
                            prev = false
                        }
                    }

                    return prev
                }, true)

                // if(storeInStorage){
                //     sessionStorage.setItem(key, lzString.compressToUTF16(JSON.stringify(answer)))
                // }
            }
        }

        if(returnAll){
            return answer
        }

        return answer.data
    })
}

export const getEcomMetrics = (siteId, startDate, endDate, signal) => {
    const options = {
        method: 'GET',
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem("token")
        }
    }

    return apiCall(`metrics/${siteId}/${startDate}/${endDate}/ecommerce`, options, null, secondaryApi, signal)
        .then(({response, error}) => {
            if(error){
                throw error
            }
            return response.result
        })
}

export const getMonthlyMetricsLongTerm = (siteId, lastYear, currentYear, format="year", signal, altToken=null, query=null) => apiCall(`metrics/month/${siteId}/${lastYear}/${currentYear}?format=${format}${altToken ? '&altToken=1': ''}${query ? '&'+ Object.keys(query).map(k => `${k}=${query[k]}`).join("&") : '' }`, {
    method: 'GET'
}, null, secondaryApi, signal, altToken)

export const putMonthlySales = (token, siteId, yearMonth, {metrics, common, seo, scoreCardSummary}) => apiCall(`metrics/month/${siteId}/${yearMonth}`, {
    method: 'PUT',
    body: {
        metrics,
        common,
        seo,
        scoreCardSummary
    }
}, token, secondaryApi)

export const exportRevenueSalesXlsDoc = (siteId) => apiCall(`metrics/${siteId}/revenue-sales-upload`, {
    method: 'GET'
}, null, secondaryApi, null, false, true)

export const uploadUnitSalesXlsDoc = (siteId, xlsFile) => {
    let data = new FormData()
    data.append("xlsFile", xlsFile)
    
    return apiCall(`metrics/${siteId}/unit-sales-upload`, {
        method: 'POST',
        body: data
    }, null, secondaryApi, null, false, true)
}

export const uploadRevenueSalesXlsDoc = (siteId, xlsFile) => {
    let data = new FormData()
    data.append("xlsFile", xlsFile)
    
    return apiCall(`metrics/${siteId}/revenue-sales-upload`, {
        method: 'POST',
        body: data
    }, null, secondaryApi, null, false, true)
}

export const exportUnitSalesXlsDoc = (siteId) => apiCall(`metrics/${siteId}/unit-sales-upload`, {
    method: 'GET'
}, null, secondaryApi, null, false, true)

export const removeMetricsFromCache = async(siteId) => apiCall(`metrics/${siteId}/cache`, {
    method: 'DELETE'
}, null, secondaryApi)

export const onUnitSalesLoad = (yearsBack=0) => {
    const now = DateTime.local().minus({years: yearsBack})
    const currentYear = parseInt(now.toFormat("yyyy"))
    const lastYear = parseInt(now.minus({year:1}).toFormat("yyyy"))
    const lastEnabledMonth = parseInt(now.toFormat("yyyyLL"))
    const currentMonth = yearsBack > 0 ? 12 : parseInt(now.toFormat("LL"))

    const startOfMonth = now.startOf('month')
    const startOfYear = now.startOf('year')
    const endOfYear = now.endOf('year').set({day: 1})
    let i = startOfYear
    let yMMIterate = parseInt(i.toFormat("yyyyLL"))

    let months = {}
    let lastYearMonths = {}
    
    while(yMMIterate <= lastEnabledMonth && i.hasSame(startOfMonth, 'year')){
        months[i.toFormat('yyyyLL')] = {
            disabled: false,
            display: capitalize(i.toFormat("LLL"))
        }
        let lYearMonth = i.set({ year: lastYear})
        lastYearMonths[lYearMonth.toFormat('yyyyLL')] = {
            disabled: false,
            display: capitalize(lYearMonth.toFormat("LLL"))
        }
        i = i.plus({month: 1})
        yMMIterate += 1
    }
    
    while(i.hasSame(endOfYear, 'year')){
        months[i.toFormat('yyyyLL')] = {
            disabled: true,
            display: capitalize(i.toFormat("LLL"))
        }
        let lYearMonth = i.set({ year: lastYear})
        lastYearMonths[lYearMonth.toFormat('yyyyLL')] = {
            disabled: false,
            display: capitalize(lYearMonth.toFormat("LLL"))
        }
        i = i.plus({month: 1})
    }

    return {
        currentMonths: months,
        lastYearMonths,
        currentYear,
        currentMonth,
        lastYear,
        startOfYear,
        lastEnabledMonth,
        startOfMonth: startOfMonth.toFormat("yyyyLL")
    }
}

export const formatMonthlySales = (results) => {
    const now = DateTime.local()
    const currentYear = parseInt(now.toFormat("yyyy"))
    const lastEnabledMonth = parseInt(now.toFormat("yyyyLL"))

    let tempFranchiseSales = {}
    let tempFranchiseTypes = {}
    let discoveryDays = {}
    let commonMetrics = {}
    let brokers = {}

    let summaryTotals = {
        years: {},
        totalUnits: 0,
        franchiseTypeUnitTotals: {}
    }
    results?.response?.result?.forEach(metric => {
        let year = metric.yearMonth.toString().substring(0, 4)
        if(discoveryDays[year] === undefined){
            discoveryDays[year] = {}
            for(let i = 1; i <= 12; i ++){
                let yMM = parseInt(year + (i > 9 ? "" + i: "0" + i));
                
                if(currentYear === parseInt(year) && lastEnabledMonth >= yMM){
                    discoveryDays[year][yMM] = 0
                } else if(currentYear !== parseInt(year)) {
                    discoveryDays[year][yMM] = 0
                }
            }
        }
        if(metric.common){
            commonMetrics[metric.yearMonth] = metric.common
            if(metric.common.discoveryDays){
                discoveryDays[year][metric.yearMonth] = metric.common.discoveryDays
            }
            if(metric.common?.brokers){
                metric.common.brokers.forEach(broker => {
                    if(brokers[broker.name] === undefined){
                        brokers[broker.name] = {
                            name: broker.name,
                            months: {}
                        }
                    }

                    console.log("bdfg", brokers)
    
                    brokers[broker.name].months[metric.yearMonth] = broker.adSpend
                })
            }
        }
        if(metric.franchiseSales){
            metric.franchiseSales.forEach(s => {
                let key = year + s.metricKey

                if(summaryTotals.franchiseTypeUnitTotals[key] === undefined){
                    summaryTotals.franchiseTypeUnitTotals[key] = {
                        year: parseInt(year),
                        metricKey: s.metricKey,
                        revenuePerUnit: s.revenuePerUnit,
                        name: s.display,
                        value: 0
                    }
                }

                
                if(summaryTotals.years[year] === undefined){
                    summaryTotals.years[year] = {
                        metrics: {}
                    }
                    for(let i = 1; i <= 12; i ++){
                        let yMM = parseInt(year + (i > 9 ? "" + i: "0" + i));
                        
                        if(currentYear === parseInt(year) && lastEnabledMonth >= yMM){
                            summaryTotals.years[year].metrics[yMM] = { value: 0, revenuePerUnit: [], revenueTotal: 0}
                        } else if(currentYear !== parseInt(year)) {
                            summaryTotals.years[year].metrics[yMM] = { value: 0, revenuePerUnit: [], revenueTotal: 0}
                        }
                    }
                    
                }
                
                if(summaryTotals.years[year].metrics[metric.yearMonth]){
                    summaryTotals.years[year].metrics[metric.yearMonth].revenuePerUnit.push(parseFloat(s.revenuePerUnit))
                    summaryTotals.years[year].metrics[metric.yearMonth].value += parseInt(s.value)
                    summaryTotals.years[year].metrics[metric.yearMonth].revenueTotal += (parseInt(s.value) * parseFloat(s.revenuePerUnit))
                }
                summaryTotals.franchiseTypeUnitTotals[key].value += parseInt(s.value)
                
                if(tempFranchiseSales[key] === undefined){
                    tempFranchiseSales[key] = {
                        metricKey: s.metricKey,
                        year: parseInt(year),
                        yearMonth: metric.yearMonth,
                        display: s.display,
                        revenuePerUnit: parseFloat(s.revenuePerUnit),
                        metrics: {}
                    }

                    tempFranchiseTypes[key] = {
                        display: s.display,
                        metricKey: s.metricKey,
                        year,
                        yearMonth: metric.yearMonth,
                        metrics: []
                    }
                }

                tempFranchiseSales[key].metrics[metric.yearMonth] = s

                tempFranchiseTypes[key].metrics[metric.yearMonth] = s
            })
        }
    })


    
    summaryTotals.franchiseTypeUnitTotals = Object.values(summaryTotals.franchiseTypeUnitTotals)
    
    let tempFranchiseTypesFiltered = {}
    
    Object.values(tempFranchiseTypes).forEach(t => {
        if(tempFranchiseTypesFiltered[t.metricKey]){
            delete tempFranchiseTypesFiltered[t.metricKey]
        } else {
            tempFranchiseTypesFiltered[t.metricKey] = t
        }
    })

    return {
        franchiseSales: Object.values(tempFranchiseSales),
        franchiseTypes: Object.values(tempFranchiseTypesFiltered),
        franchiseTypesUnfiltered: Object.values(tempFranchiseTypes),
        summaryTotals,
        discoveryDays,
        commonMetrics,
        brokers: Object.values(brokers)
    }
}

export const summarizeMonthlySales = (monthMetric) => {
    const defaultObj = {
        units: 0,
        revenue: 0,
        avgRevenuePerSale: 0
    }
    const summary = monthMetric.franchiseSales ? monthMetric.franchiseSales.reduce((prev, curr, idx, arr) => {
        prev.units += parseInt(curr.value)
        prev.revenue += (parseInt(curr.value) * curr.revenuePerUnit)
        
        if(idx === arr.length - 1){
            prev.avgRevenuePerSale = prev.revenue / prev.units
        }
        
        return prev
    }, {
        ...defaultObj
    }) : {
        ...defaultObj
    }
    
    return summary
}

export const summarizeMonthlyAnalytics = (monthMetric) => {
    let gaGoals = 0
    let gaSessions = 0
    let gaAdCost = 0
    let gaBounces = 0
    let gaDuration = 0
    let gaPgViews = 0
    let gaNewUsers = 0
    let gaPgLoadTime = 0
    let gaPgLoadSample = 0

    let gaDesktopSessions = 0
    let gaMobileSessions = 0
    let gaTabletSessions = 0

    if(monthMetric.ga.reports[0]){
        gaSessions = monthMetric.ga.reports[0].data.totals[0].values[0]
        gaNewUsers = monthMetric.ga.reports[0].data.totals[0].values[1]
        gaBounces = monthMetric.ga.reports[0].data.totals[0].values[4]
        gaDuration = monthMetric.ga.reports[0].data.totals[0].values[5]
        gaPgViews = monthMetric.ga.reports[0].data.totals[0].values[6]
    }
    if(monthMetric.ga.reports[1]){
        gaPgLoadTime = monthMetric.ga.reports[1].data.totals[0].values[2]
        gaPgLoadSample = monthMetric.ga.reports[1].data.totals[0].values[3]
    }
    if(monthMetric.ga.reports[5]){
        gaAdCost = monthMetric.ga.reports[5].data.totals[0].values[3]
        gaGoals = monthMetric.ga.reports[5].data.totals[0].values[5]
    }
    if(monthMetric.ga.reports[6]){
        gaAdCost = monthMetric.ga.reports[6].data.totals[0].values[3]
        gaGoals = monthMetric.ga.reports[6].data.totals[0].values[5]
    }
    if(monthMetric.ga.reports[8]){
        gaDesktopSessions = monthMetric.ga.reports[8].data.totals[0].values[0]
    }
    if(monthMetric.ga.reports[9]){
        gaMobileSessions = monthMetric.ga.reports[9].data.totals[0].values[0]
    }
    if(monthMetric.ga.reports[10]){
        gaTabletSessions = monthMetric.ga.reports[10].data.totals[0].values[0]
    }

    return {
        ga: {
            sessions: parseInt(gaSessions),
            desktopSessions: parseInt(gaDesktopSessions),
            mobileSessions: parseInt(gaMobileSessions),
            tabletSessions: parseInt(gaTabletSessions),
            goals: parseInt(gaGoals),
            adCost: parseFloat(gaAdCost),
            bounces: parseInt(gaBounces),
            avgVisitDuration: formatDuration(parseFloat(gaDuration), parseInt(gaSessions)),
            avgPagesPerVisit: parseInt(gaSessions) > 0 ? formatAverage(parseInt(gaPgViews), parseInt(gaSessions)) : 0,
            retSessions: Math.round(100*(parseInt(gaSessions)-parseInt(gaNewUsers))/parseInt(gaSessions)),
            avgPageLoad: parseInt(gaPgLoadTime) > 0 ? formatAverage(parseInt(gaPgLoadTime), parseInt(gaPgLoadSample)*1000) : 0
        }
    }

}

export const processEcomMetrics = async(dateRangeMetrics) =>{
    let trafReport = [...dateRangeMetrics]
    let perf = {}

    let date_times = {}
    let startDate = null
    let endDate = null

    let adMetrics = []
    let gaEcomProductMetrics = []
    let gaEcomMetrics = []
    let gaEcomDeviceCategoryMetrics = []
    let gaEcomCampaignMetrics = []
    let gaEcomSrcMedMetrics = []

    let emailEcomMetrics = []

    let otherAdsEcomMetrics = []

    for(let k = 0; k < trafReport.length; k++) {
        let dayMetrics = {...trafReport[k]}

        let date = dayMetrics.date
        let ts = DateTime.fromISO(date)

        date_times[date] = ts.toMillis()

        let ga_reports = []
        let hasBuffer = false

        if(dayMetrics.ga && dayMetrics?.ga?.type === "Buffer"){
            hasBuffer = true
            let gaBinary = await gunzip(Buffer.from(dayMetrics.ga))

            let gaConv = JSON.parse(gaBinary)
            if(gaConv === null || gaConv.reports === null || gaConv.reports[0].data === undefined){
                if(!gaConv.reports[0].rows){
                    ga_reports = []
                }
            }
            ga_reports = gaConv?.reports ?? []

            dayMetrics.ga = gaConv


        } else {
            // if(dayMetrics.ga === null || 
            //     dayMetrics?.ga?.reports === null || 
            //     dayMetrics?.ga?.reports[0] === undefined || 
            //     dayMetrics?.ga?.reports[0].data === undefined){
            //     if(!dayMetrics?.ga?.reports || !dayMetrics?.ga?.reports[0] || !dayMetrics?.ga?.reports[0].rows){
            //         return
            //     }
            // }

            ga_reports = dayMetrics?.ga?.reports ?? []
        }

        if(hasBuffer){
            trafReport[k] = {...dayMetrics}
        }

        if(k === 0){
            startDate = date
        }
        if(trafReport.length -1 === k){
            endDate = date
        }


        if (ga_reports[0] && ga_reports[0].data && ga_reports[0].data.rows) {
            ga_reports[0].data.rows.forEach(row => {
                if (row.dimensions[0] !== '(not set)') {
                    adMetrics.push([...row.metrics[0].values, date, row.dimensions[1], row.dimensions[0]])
                }
            })
        } else if(ga_reports[0] && ga_reports[0].rows){
            ga_reports[0].rows.forEach(row => {
                if (row.dimensionValues[0].value !== '(not set)' &&
                    row.dimensionValues[0].value !== '') {
                    let m = ga4HeaderAsArray(row.metricValues)
                    adMetrics.push([...m, date, row.dimensionValues[1].value, row.dimensionValues[0].value])
                }
            })
        }

        if (ga_reports[1] && ga_reports[1].data && ga_reports[1].data.rows) {
            ga_reports[1].data.rows.forEach(row => {
                gaEcomMetrics.push([...row?.metrics[0].values.map(v => parseFloat(v)), date])
                gaEcomDeviceCategoryMetrics.push([...row?.metrics[0].values.map(v => parseFloat(v)), date, row.dimensions ? row.dimensions[2] : "", row.dimensions ? row.dimensions[0] : ""])
                gaEcomSrcMedMetrics.push([...row?.metrics[0].values.map(v => parseFloat(v)), date, row.dimensions ? row.dimensions[2] : ""])
                
                if (row.dimensions && row.dimensions[1] && row.dimensions[1] !== '(not set)' && row.dimensions[2] && row.dimensions[2].indexOf("cpc") !== -1){
                    gaEcomCampaignMetrics.push([...row?.metrics[0].values.map(v => parseFloat(v)), date, row.dimensions ? row.dimensions[2] : "", row.dimensions ? row.dimensions[1] : ""])
                }

                if (row.dimensions[1] !== '(not set)') {
                    if (row.dimensions[2].toLowerCase().includes('email')){
                        emailEcomMetrics.push([...row.metrics[0].values, date, row.dimensions[3], row.dimensions[2], row.dimensions[1]])
                    } else {

                        const channels = [...Object.values(socialChannels).map(s => s[0])]

                        const hasSocial = channels.reduce((prev, curr) => {
                            if(row.dimensions[2].toLowerCase().includes(curr)){
                                prev = true
                            }

                            return prev
                            
                        }, false)
                        if(!row.dimensions[2].includes("cpc") &&
                        !hasSocial && 
                        row.dimensions[2].toLowerCase() != 'psocial' &&
                        row.dimensions[3].toLowerCase().indexOf("bing") == -1 &&
                        row.dimensions[3].toLowerCase() !== "google-my-place") {
                            otherAdsEcomMetrics.push([...row.metrics[0].values, date, row.dimensions[3], row.dimensions[1]])
                        }
                    }
                }
            })
        } else if(ga_reports[1] && ga_reports[1].rows){
            ga_reports[1].rows.forEach(row => {
                let m = ga4HeaderAsArray(row?.metricValues)

                gaEcomMetrics.push([...m.map(v => parseFloat(v)), date])
                gaEcomDeviceCategoryMetrics.push([...m.map(v => parseFloat(v)), date, row.dimensionValues ? row.dimensionValues[2].value : "", row.dimensionValues ? row.dimensionValues[0].value : ""])
                gaEcomSrcMedMetrics.push([...m.map(v => parseFloat(v)), date, row.dimensionValues ? row.dimensionValues[2].value : ""])
                
                if (row.dimensionValues && 
                    row.dimensionValues[1] && 
                    row.dimensionValues[1].value !== '(not set)' && 
                    row.dimensionValues[2].value && row.dimensionValues[2].value.indexOf("cpc") !== -1){
                    gaEcomCampaignMetrics.push([...m.map(v => parseFloat(v)), date, row.dimensionValues ? row.dimensionValues[2].value : "", row.dimensionValues ? row.dimensionValues[1].value : ""])
                }

                
                if (row.dimensionValues[1].value !== '(not set)') {
                    if (row.dimensionValues[2].value.toLowerCase().includes('email')){
                        emailEcomMetrics.push([...m, date, row.dimensionValues[3].value, row.dimensionValues[2].value, row.dimensionValues[1].value])
                    } else {
                        const channels = [...Object.values(socialChannels).map(s => s[0])]

                        const hasSocial = channels.reduce((prev, curr) => {
                            if(row.dimensionValues[2].value.toLowerCase().includes(curr)){
                                prev = true
                            }

                            return prev

                        }, false)

                        if(!row.dimensionValues[2].value.includes("cpc") &&
                            !hasSocial && 
                            row.dimensionValues[2].value.toLowerCase() != 'psocial' &&
                            row.dimensionValues[3].value.toLowerCase().indexOf("bing") == -1 &&
                            row.dimensionValues[3].value.toLowerCase() !== "google-my-place") {
                            otherAdsEcomMetrics.push([...m, date, row.dimensionValues[3].value, row.dimensionValues[1].value])
                        }
                    }
                }
            })
        }

        if (ga_reports[2] && ga_reports[2].data && ga_reports[2].data.rows) {
            ga_reports[2].data.rows.forEach(row => {
                gaEcomProductMetrics.push([...row.metrics[0].values, date, row.dimensions[0], row.dimensions[1]])
            })
        } else if(ga_reports[2] && ga_reports[2].rows){
            ga_reports[2].rows.forEach(row => {
                let m = ga4HeaderAsArray(row?.metricValues)
                gaEcomProductMetrics.push([...m, date, row.dimensionValues[0].value, row.dimensionValues[1].value])
            })
        }
    }

    perf.gaEcomMetrics = gaEcomMetrics

    perf.gaEcomRevenue = 0
    perf.gaEcomAvgOrderVal = 0
    perf.gaEcomTransactions = 0
    perf.gaEcomSessions = 0
    perf.gaEcomGCR = 0
    perf.gaEcomROAS = 0
    perf.gaEcomAdSpend = 0
    perf.gaEcomRevenueWSpend = 0
    perf.gaOtherEcomRevenue = 0
    perf.gaOtherEcomTransactions = 0

    perf.gaEcomMetricsByDay = sumByLastIndex(gaEcomMetrics)
    perf.gaEcomMetricsByProduct = sumByLastIndex(gaEcomProductMetrics)


    perf.gaEcomRevenueByProduct = 0
    perf.gaEcomMetricsByProduct.forEach(prod => {
        perf.gaEcomRevenueByProduct += parseFloat(prod[1][0])
    })

    otherAdsEcomMetrics.forEach(vals => {
        perf.gaOtherEcomRevenue += parseFloat(vals[4])
        perf.gaOtherEcomTransactions += parseInt(vals[1])
    })

    perf.otherAdsEcomMetricsRaw = otherAdsEcomMetrics
    perf.otherAdsEcomMetrics = Object.values(otherAdsEcomMetrics).reduce((prev, curr, idx, arr) => {
        if(prev[curr[curr.length - 1]] === undefined){
            prev[curr[curr.length - 1]] = {}
        }

        if(prev[curr[curr.length - 1]][curr[curr.length - 2]] === undefined){
            prev[curr[curr.length - 1]][curr[curr.length - 2]] = {
                id: curr[curr.length - 1],
                source: curr[curr.length - 2],
                sessions: 0,
                revenue: 0,
                transactions: 0,
                sesDur: 0,
                sesPgs: 0
            }
        }

        prev[curr[curr.length - 1]][curr[curr.length - 2]].sessions += +curr[0]
        prev[curr[curr.length - 1]][curr[curr.length - 2]].transactions += +curr[1]
        prev[curr[curr.length - 1]][curr[curr.length - 2]].revenue += +curr[4]

        if(idx === arr.length - 1){
            Object.keys(prev).forEach(campaign => {
                prev.arr.push(...Object.values(prev[campaign]))

            })
        }

        return prev
    }, {
        arr: []
    }).arr
    perf.otherAdsEcomMetricTotals = sumArrays(sumByLastIndex(otherAdsEcomMetrics).map(el => el[1]))
    
    perf.gaEcomMetricsDetails = perf.gaEcomMetricsByDay.reduce((prev, curr, idx, arr) => {
        let dt = date_times[curr[0]]

        prev[0].values.push([dt, parseFloat(curr[1][4]).toFixed(2)])
        prev[1].values.push([dt, parseInt(curr[1][1])])

        perf.gaEcomSessions += parseInt(curr[1][0])
        perf.gaEcomTransactions += parseInt(curr[1][1])
        perf.gaEcomRevenue += parseFloat(curr[1][4])
        perf.gaEcomAdSpend += parseFloat(curr[1][6])

        if(parseFloat(curr[1][6]) > 0){
            perf.gaEcomRevenueWSpend += parseFloat(curr[1][4])
        }

        if(parseFloat(curr[1][4]) > parseFloat(prev[0]._highestValue)){
            prev[0]._highestValue = parseFloat(curr[1][4])
        }

        if((parseInt(curr[1][1])) > parseFloat(prev[1]._highestValue)){
            prev[1]._highestValue = parseInt(curr[1][1])
        }

        if(idx === (arr.length - 1)){
            perf.gaEcomGCR = parseFloat((perf.gaEcomTransactions / perf.gaEcomSessions).toFixed(2))
            perf.gaEcomROAS = parseFloat((perf.gaEcomRevenueWSpend / perf.gaEcomAdSpend).toFixed(2))
        }
        
        return prev
    }, [
        { key: "Revenue", values: [], yAxis: 1, _highestValue: 0},
        { key: "Transactions", values: [], yAxis: 2, _highestValue: 0}
    ])
    perf.gaEcomAvgOrderVal = parseFloat((perf.gaEcomRevenue / perf.gaEcomTransactions).toFixed(2))
    
    perf.gaEcomMetricsByCategory = sumByLastIndex(gaEcomDeviceCategoryMetrics)

    perf.gaEcomMetricsByCategoryTotals = sumArrays(perf.gaEcomMetricsByCategory.map(el => el[1]))

    perf.gaEcomMetricsBySrcMedCat = Object.values(gaEcomDeviceCategoryMetrics.reduce((prev, curr, idx, arr) => {
        let sessMed = curr[curr.length - 2]
        let category = curr[curr.length - 1]

        if(prev[sessMed] === undefined){
            prev[sessMed] = {}
        }

        if(prev[sessMed][category] === undefined){
            let iconKey = Object.keys(iconDictionaryByMed).filter(i => sessMed.includes(i))[0]
            let icon = iconDictionaryByMed[iconKey] ?? ""
            prev[sessMed][category] = {
                sessMed,
                category,
                icon,
                views: 0,
                adds: 0,
                checkouts: 0,
                revenue: 0
            }
        }

        prev[sessMed][category].views += +curr[7]
        prev[sessMed][category].adds += +curr[8]
        prev[sessMed][category].checkouts += +curr[9]
        prev[sessMed][category].revenue += +curr[4]

        if(idx === arr.length - 1){
            Object.keys(prev).forEach(k => {
                prev[k] = Object.values(prev[k])
            })
        }

        return prev
    }, {})).flat()

    perf.gaEcomMetricsByCategoryDetails = perf.gaEcomMetricsByCategory.map(src => ({
        id: src[0],
        ecr: src[1][1] / src[1][0],
        transactions: src[1][1],
        revenue: src[1][3]
    }))

    perf.gaEcomSrcMedMetrics = sumByLastIndex(gaEcomSrcMedMetrics)
    perf.gaEcomSrcMedMetricsRaw = gaEcomSrcMedMetrics
    perf.gaEcomSrcMedMetricDailies = gaEcomSrcMedMetrics.reduce((prev, curr) => {
        const srcMed = curr[curr.length -1]
        const date = curr[curr.length -2]
        const transactions = +curr[1]
        const revenue = +curr[4]

        if(prev[srcMed] === undefined){
            prev[srcMed] = {
                srcMed,
                revenue: 0,
                transactions: 0
            }
        }

        if(prev[srcMed][date] === undefined){
            prev[srcMed][date] = {
                revenue: 0,
                transactions: 0
            }
        }

        prev[srcMed].transactions += transactions
        prev[srcMed].revenue += revenue

        prev[srcMed][date].transactions += transactions
        prev[srcMed][date].revenue += revenue

        return prev
    }, {})
    perf.gaEcomCampaignMetrics = sumByLastIndex(gaEcomCampaignMetrics)
    perf.gaEcomCampaignMetricTotals = sumArrays(perf.gaEcomCampaignMetrics.map(el => el[1]))

    perf.gaEcomCampaignMetricsByChannel = gaEcomCampaignMetrics.reduce((prev, curr, idx, arr) => {
        if(curr[curr.length - 2] === "bing / cpc") {
            prev.bingCpc.rows.push(curr)
        }

        if(arr.length - 1 === idx){
            prev.bingCpc.totals = prev.bingCpc.rows.length > 0 ? sumByLastIndex(prev.bingCpc.rows) : [] 
            prev.bingCpc.campaignTotals = prev.bingCpc.rows.length > 0 ? sumArrays(prev.bingCpc.totals.map(el => el[1])) : [] 
        }

        return prev
    }, {
        bingCpc: {
            rows: [],
            totals: [],
            campaignTotals: []
        }
    })

    perf.gaEcomMetricOrganicSum = perf.gaEcomSrcMedMetrics.reduce((map, item) => {
        if(item[0].includes("organic")){
            map.count ++
            map.sessions += item[1][0]
            map.transactions += item[1][1]
            map.revenue += item[1][4]
        }

        return map
    }, {
        count: 0,
        sessions: 0,
        transactions: 0,
        revenue: 0
    })

    perf.gaEcomMetricByMedium = perf.gaEcomSrcMedMetrics.reduce((map, item) => {
        const med = item[0].split("/")[1] ? item[0].split("/")[1].trim() : ""
        if(map[med] === undefined){
            map[med] = {
                count: 0,
                sessions: 0,
                transactions: 0,
                revenue: 0,
                items: []
            }
        }

        map[med].count ++
        map[med].sessions += item[1][0]
        map[med].transactions += item[1][1]
        map[med].revenue += item[1][4]
        map[med].items.push(item)

        return map
    }, {})

    perf.adsByCompaign = sumByLastIndex(adMetrics)
    perf.adsByCompaignTop = perf.adsByCompaign.sort((a, b) => +a[1][2]>+b[1][2] ? -1 : +a[1][2] === +b[1][2] ? 0 : 1).slice(0, 5) // top 5 clicks
    perf.adsByCompaignDetails = perf.adsByCompaignTop.map(ad => {
        let campaign = ad[0]
        let recs = []
        trafReport.forEach(dayMetrics => {
            if (dayMetrics.ga && dayMetrics.ga.reports[5] && dayMetrics.ga.reports[5].data && dayMetrics.ga.reports[5].data.rows) {
                recs.push([dayMetrics.date, dayMetrics.ga.reports[5].data
                    .rows.filter(row => row.dimensions[0] === campaign)])
            }
        })
        return {key: campaign, values: recs.map(row => [date_times[row[0]], row[1].length ?
            row[1].reduce((a, b) => a+(+b.metrics[0].values[2]), 0) : 0])}
    })
    perf.adsByCompaignTotal = sumArrays(perf.adsByCompaign.map(el => el[1]))

    perf.emailEcomRevenue = 0
    perf.emailEcomTransactions = 0
    
    emailEcomMetrics.forEach(e => {
        perf.emailEcomRevenue += (+e[4])
        perf.emailEcomTransactions += (+e[1])
    })

    perf.emailEcomMetrics = Object.values(emailEcomMetrics).reduce((prev, curr, idx, arr) => {
        if(prev[curr[curr.length - 1]] === undefined){
            prev[curr[curr.length - 1]] = {}
        }

        if(prev[curr[curr.length - 1]][curr[curr.length - 3]] === undefined){
            prev[curr[curr.length - 1]][curr[curr.length - 3]] = {
                id: curr[curr.length - 1],
                source: curr[curr.length - 3],
                sessions: 0,
                revenue: 0,
                transactions: 0,
                sesDur: 0,
                sesPgs: 0
            }
        }

        prev[curr[curr.length - 1]][curr[curr.length - 3]].sessions += +curr[0]
        prev[curr[curr.length - 1]][curr[curr.length - 3]].transactions += +curr[1]
        prev[curr[curr.length - 1]][curr[curr.length - 3]].revenue += +curr[4]

        if(idx === arr.length - 1){
            Object.keys(prev).forEach(campaign => {
                prev.arr.push(...Object.values(prev[campaign]))

            })
        }

        return prev
    }, {
        arr: []
    }).arr
    perf.emailEcomMetricTotals = sumArrays(sumByLastIndex(emailEcomMetrics).map(el => el[1]))

    return perf
}

export const processMonthlyMetric = async(monthMetric, returnRegardless=false) => {
    let perf = {}
    let ga_reports = []
    let monthMetricObj = {
        ...monthMetric
    }

    let mediumMetrics = []
    let mobileMediumMetrics = []
    let sourceMediumMetrics = []
    let sourceMediumMetricsNonCpc = []
    let deviceCategoryMetrics = []
    let orgDeviceCategoryMetrics = []

    let dcMetricsAdd = []
    let brMetrics = []
    let ldMetrics = []
    
    let mobileSourceMediumMetrics = []
    let mobileSourceMediumMetricsNonCpc = []

    let userTypeMetrics = []
    let goalMetrics = []
    let goals = {}
    let evMetrics = []

    let adMetrics = []
    
    let ecomAdMetrics = []
    let ecomMetrics = []

    let otherAdMetrics = []
    let adMetricsByDevice = []
    let mobileOtherAdMetrics = []
    let fbMetrics = []
    let fbPixelMetrics = []
    let fbFanMetrics = []
    let gmbAdMetrics = []
    let gmbMetrics = []

    let cityMetrics = []
    let leadsBySrcMedHour = []

    let gaEcomProductMetrics = []
    let gaEcomMedMetrics = []
    let gaEcomDeviceMetrics = []

    
    let bingMetrics = []
    let bingMetricsByDeviceType = []
    let bingCampaignMetrics = []
    
    let linkedinMetrics = []
    let emailEcomMetrics = []
    let emailSrcMedMetrics = []

    let otherAdsEcomMetrics = []

    let sourceToCampaignMap = {}

    let gaEcomCampaignMetrics = []

    let hasBuffer = false

    if(monthMetricObj && monthMetricObj.ga && monthMetricObj.ga.type === "Buffer"){
        hasBuffer = true
        let gaBinary = {}
        try {
            gaBinary = await gunzip(Buffer.from(monthMetricObj.ga.data))
        } catch(e){
            const decompressedUint8 = brotliDecompress(Buffer.from(monthMetricObj.ga.data))
            gaBinary = new TextDecoder('utf-8').decode(decompressedUint8)
        }

        let gaConv = JSON.parse(gaBinary)
        if(gaConv === null || gaConv.reports === null || gaConv.reports === undefined || gaConv.reports[0].data === undefined){
            if(!gaConv.reports || gaConv.reports[0].rows === undefined) {
                if(!returnRegardless){ 
                    return {}
                } else {
                    return {
                        ...monthMetricObj
                    }
                }
            }
        }

        ga_reports = gaConv.reports

        monthMetricObj.ga = gaConv


    } else {
        if(monthMetricObj === undefined || monthMetricObj.ga === null || monthMetricObj.ga === undefined || monthMetricObj?.ga?.reports === undefined || monthMetricObj.ga.reports[0].data === undefined){
            if(!returnRegardless){ 
                return {}
            } else {
                return {
                    ...monthMetricObj
                }
            }
        }

        ga_reports = monthMetricObj.ga.reports
    }

    if(monthMetricObj && monthMetricObj.gaEcom && monthMetricObj.gaEcom.type === "Buffer"){
        hasBuffer = true
        let gaEcomBinary = {}
        try {
            gaEcomBinary = await gunzip(Buffer.from(monthMetricObj.gaEcom.data))
        } catch(e){
            const decompressedUint8 = brotliDecompress(Buffer.from(monthMetricObj.gaEcom.data))
            gaEcomBinary = new TextDecoder('utf-8').decode(decompressedUint8)
        }

        let gaEcomConv = JSON.parse(gaEcomBinary)

        monthMetricObj.gaEcom = gaEcomConv
    }

    if(monthMetricObj && monthMetricObj.fb && monthMetricObj.fb.type === "Buffer"){
        hasBuffer = true
        let fbBinary = await gunzip(Buffer.from(monthMetricObj.fb.data))

        let fbConv = JSON.parse(fbBinary)

        monthMetricObj.fb = fbConv
    }
    if(monthMetricObj && monthMetricObj.fbPage && monthMetricObj.fbPage.type === "Buffer"){
        hasBuffer = true
        let fbPageBinary = await gunzip(Buffer.from(monthMetricObj.fbPage.data))

        let fbPageConv = JSON.parse(fbPageBinary)

        monthMetricObj.fbPage = fbPageConv
    }
    if(monthMetricObj && monthMetricObj.gmb && monthMetricObj.gmb.type === "Buffer"){
        hasBuffer = true
        let gmbBinary = await gunzip(Buffer.from(monthMetricObj.gmb.data))

        let gmbConv = JSON.parse(gmbBinary)

        monthMetricObj.gmb = gmbConv
    }
    if(monthMetricObj && monthMetricObj.linkedin && monthMetricObj.linkedin.type === "Buffer"){
        hasBuffer = true
        let linkedinBinary = await gunzip(Buffer.from(monthMetricObj.linkedin.data))

        let linkedinConv = JSON.parse(linkedinBinary)

        monthMetricObj.linkedin = linkedinConv
    }
    if(monthMetricObj && monthMetricObj.linkedinOrg && monthMetricObj.linkedinOrg.type === "Buffer"){
        hasBuffer = true
        let linkedinOrgBinary = await gunzip(Buffer.from(monthMetricObj.linkedinOrg.data))

        let linkedinOrgConv = JSON.parse(linkedinOrgBinary)

        monthMetricObj.linkedinOrg = linkedinOrgConv
    }
    if(monthMetricObj && monthMetricObj.bing && monthMetricObj.bing.type === "Buffer"){
        hasBuffer = true
        let bingBinary = await gunzip(Buffer.from(monthMetricObj.bing.data))

        let bingConv = JSON.parse(bingBinary)

        monthMetricObj.bing = bingConv
    }
    
    if(monthMetricObj === undefined || monthMetricObj.ga === null || monthMetricObj.ga.reports === null || (
        monthMetricObj.ga.reports[0].rows === undefined &&
        monthMetricObj.ga.reports[0].data === undefined)) {
        if(!returnRegardless){
            return {}
        } else {
            return {
                ...monthMetricObj
            }
        }
    }
    if(monthMetricObj.gmb && Array.isArray(monthMetricObj.gmb)) {
        gmbMetrics.push(monthMetricObj.gmb)
    }

    let hasGa4=false

    if (ga_reports[0].data && ga_reports[0].data.rows) {
        ga_reports[0].data.rows.forEach(row => {
            mediumMetrics.push([...row.metrics[0].values, row.dimensions[0]])
            sourceMediumMetrics.push([...row.metrics[0].values, row.dimensions[1]])
            if(!row.dimensions[0].includes("cpc")){
                sourceMediumMetricsNonCpc.push([...row.metrics[0].values, row.dimensions[1]])
            }
            if (row.dimensions[2] === 'mobile') {
                mobileMediumMetrics.push([...row.metrics[0].values, row.dimensions[0]])
                mobileSourceMediumMetrics.push([...row.metrics[0].values, row.dimensions[1]])
                if(!row.dimensions[0].includes("cpc")){
                    mobileSourceMediumMetricsNonCpc.push([...row.metrics[0].values, row.dimensions[1]])
                }
            }
            deviceCategoryMetrics.push([...row.metrics[0].values, row.dimensions[2]])
            userTypeMetrics.push([...row.metrics[0].values, row.dimensions[3]])

            if(row.dimensions[1].includes("organic")){
                orgDeviceCategoryMetrics.push([...row.metrics[0].values, row.dimensions[2]])
            }
        })
    } else if(ga_reports[0] && ga_reports[0].rows) {
        hasGa4 = true
        ga_reports[0].rows?.forEach(row => {
            let m = ga4HeaderAsArray([...row.metricValues])

            mediumMetrics.push([...m, row.dimensionValues[0].value])
            sourceMediumMetrics.push([...m, row.dimensionValues[1].value])

            if(!row.dimensionValues[0].value.includes("cpc")){
                sourceMediumMetricsNonCpc.push([...m, row.dimensionValues[1].value])
            }
            if (row.dimensionValues[2].value === 'mobile') {
                mobileMediumMetrics.push([...m, row.dimensionValues[0].value])
                mobileSourceMediumMetrics.push([...m, row.dimensionValues[1].value])

                if(!row.dimensionValues[0].value.includes("cpc")){
                    mobileSourceMediumMetricsNonCpc.push([...m, row.dimensionValues[1].value])
                }
            }
            deviceCategoryMetrics.push([...m, row.dimensionValues[2].value])
            userTypeMetrics.push([...m, row.dimensionValues[3].value])

            if(row.dimensionValues[1].value.includes("organic")){
                orgDeviceCategoryMetrics.push([...m, row.dimensionValues[2].value])
            }
        })
    }
    // if (ga_reports[1].data && ga_reports[1].data.rows) {
    //     ga_reports[1].data.rows.forEach(row => {
    //         dcMetricsAdd.push([...row.metrics[0].values, date, row.dimensions[0]])
    //         brMetrics.push([...row.metrics[0].values, date, row.dimensions[1]])
    //         ldMetrics.push([...row.metrics[0].values, date])
    //     })
    // }
    // if (ga_reports[2].data && ga_reports[2].data.rows) {
    //     ga_reports[2].data.rows.forEach(row => {
    //         row.metrics[0].values.forEach((value, idx) => {
    //             if (+value === 0) {
    //                 return
    //             }
    //             let gname = `goal${idx+1}`
    //             goals[gname] = goals[gname]||[]
    //             goals[gname].push([...row.dimensions, value])
    //         })
    //     })
    // }
    // if (ga_reports[3].data && ga_reports[3].data.rows) {
    //     ga_reports[3].data.rows.forEach(row => {
    //         row.metrics[0].values.forEach((value, idx) => {
    //             if (+value === 0) {
    //                 return
    //             }
    //             let gname = `goal${idx+11}`
    //             goals[gname] = goals[gname]||[]
    //             goals[gname].push([...row.dimensions, value])
    //         })
    //     })
    // }
    // if (ga_reports[4].data && ga_reports[4].data.rows) {
    //     ga_reports[4].data.rows.forEach(row => {
    //         evMetrics.push([...row.metrics[0].values, date, row.dimensions[1], row.dimensions[3], row.dimensions[0]])
    //     })
    // }
    if (ga_reports[5] && ga_reports[5].data && ga_reports[5].data.rows) {
        ga_reports[5].data.rows.forEach(row => {
            if (row.dimensions[0] !== '(not set)') {
                adMetrics.push([...row.metrics[0].values, row.dimensions[1], row.dimensions[0]])
            }
        })
    } else if(ga_reports[5] && ga_reports[5].rows) {
        ga_reports[5].rows?.forEach(row => {
            let m = ga4HeaderAsArray([...row.metricValues])
            if (row.dimensionValues[0].value !== '(not set)') {
                adMetrics.push([...m, row.dimensionValues[1].value, row.dimensionValues[0].value])
            }
        })
    }

    if (ga_reports[6] && ga_reports[6].data && ga_reports[6].data.rows) {
        ga_reports[6].data.rows.forEach(row => {
            if (row.dimensions[0] !== '(not set)') {
                if (row.dimensions[0].toLowerCase().includes("email") || 
                    row.dimensions[2].toLowerCase().includes('email')){
                    
                    emailSrcMedMetrics.push([...row.metrics[0].values, row.dimensions[3], row.dimensions[0]])
                        
                } else {
                    if(!row.dimensions[2].includes("cpc") &&
                        !row.dimensions[2].toLowerCase().includes("linkedin") && 
                        row.dimensions[2].toLowerCase() != 'psocial' &&
                        row.dimensions[3].toLowerCase() !== "facebook" && 
                        row.dimensions[3].toLowerCase() !== "facebook_ads" && 
                        row.dimensions[3].toLowerCase().indexOf("bing") == -1 &&
                        row.dimensions[3].toLowerCase() !== "google-my-place") {
                            if(row.dimensions[1] == 'mobile'){
                                mobileOtherAdMetrics.push([...row.metrics[0].values, row.dimensions[3], row.dimensions[0]])
                            }

                            otherAdMetrics.push([...row.metrics[0].values, row.dimensions[3], row.dimensions[0]])
                            // otherAdDeviceMetrics.push([...row.metrics[0].values, row.dimensions[2], row.dimensions[1]])
                    }
                    
                    if(row.dimensions[3].toLowerCase() === "google-my-place") {
                        gmbAdMetrics.push([...row.metrics[0].values, row.dimensions[3], row.dimensions[0]])                            
                    }
                }
            }
        })
    } else if(ga_reports[6] && ga_reports[6].rows){
        ga_reports[6].rows.forEach(row => {
            if (row.dimensionValues[0].value !== '(not set)') {
                let m = ga4HeaderAsArray([...row.metricValues])

                if (row.dimensionValues[0].value.toLowerCase().includes("email") || 
                    row.dimensionValues[2].value.toLowerCase().includes('email')){
                    
                    emailSrcMedMetrics.push([...m, row.dimensionValues[3].value, row.dimensionValues[0].value])
                        
                } else {
                    if(!row.dimensionValues[2].value.includes("cpc") &&
                        !row.dimensionValues[2].value.toLowerCase().includes("linkedin") && 
                        row.dimensionValues[2].value.toLowerCase() != 'psocial' &&
                        row.dimensionValues[3].value.toLowerCase() !== "facebook" && 
                        row.dimensionValues[3].value.toLowerCase() !== "facebook_ads" && 
                        row.dimensionValues[3].value.toLowerCase().indexOf("bing") == -1 &&
                        row.dimensionValues[3].value.toLowerCase() !== "google-my-place") {
                            if(row.dimensionValues[1].value == 'mobile'){
                                mobileOtherAdMetrics.push([...m, row.dimensionValues[3].value, row.dimensionValues[0].value])
                            }

                            otherAdMetrics.push([...m, row.dimensionValues[3].value, row.dimensionValues[0].value])
                            // otherAdDeviceMetrics.push([...m, row.dimensionValues[2].value, row.dimensionValues[1].value])
                    }
                    
                    if(row.dimensionValues[3].value.toLowerCase() === "google-my-place") {
                        gmbAdMetrics.push([...m, row.dimensionValues[3].value, row.dimensionValues[0].value])                            
                    }
                }
            }
        })
    }


    if (ga_reports[7] && ga_reports[7].data && ga_reports[7].data.rows) {
        ga_reports[7].data.rows.forEach(row => {
            leadsBySrcMedHour.push([...row.metrics[0].values, ...row.dimensions])
        })
    } else if(ga_reports[7] && ga_reports[7].rows){
        ga_reports[7].rows.forEach(row => {
            let m = ga4HeaderAsArray(row.metricValues)
            let d = ga4HeaderAsArray(row.dimensionValues)

            leadsBySrcMedHour.push([...m, ...d])
        })
    }


    if (ga_reports[8] && ga_reports[8].data && ga_reports[8].data?.rows) {
        ga_reports[8].data.rows.forEach(row => {
            cityMetrics.push([...row.metrics[0].values, ...row.dimensions])
        })
    } else if(ga_reports[8] && ga_reports[8].rows){
        ga_reports[8].rows.forEach(row => {
            let m = ga4HeaderAsArray(row.metricValues)
            let d = ga4HeaderAsArray(row.dimensionValues)

            cityMetrics.push([...m, ...d])
        })
    }

    if (monthMetricObj.fb && monthMetricObj.fb.reports[0]) {
        monthMetricObj.fb.reports[0].data.rows?.forEach(row =>  fbMetrics.push([row]))
    }

    if(monthMetricObj.bing && monthMetricObj.bing.reports){
        if(monthMetricObj.bing.reports[0]){
            monthMetricObj.bing.reports[0].data.rows?.forEach(row => {
                bingMetrics.push([row])
                bingMetricsByDeviceType.push([...row.values[0], row.values[0][9]])
            })
        }
        if(monthMetricObj.bing.reports[1]){
            monthMetricObj.bing.reports[1].data.rows?.forEach(row => bingCampaignMetrics.push([...row.values[0], row.values[0][1], row.values[0][0]]))
        }
    }


    if (monthMetricObj.gaEcom?.reports && monthMetricObj.gaEcom?.reports[0] && monthMetricObj.gaEcom?.reports[0].data && monthMetricObj.gaEcom?.reports[0].data.rows) {
        monthMetricObj.gaEcom?.reports[0].data.rows.forEach(row => {
            ecomMetrics.push([...row.metrics[0].values, row.dimensions[1]])
            if (row.dimensions[0] !== '(not set)') {
                ecomAdMetrics.push([...row.metrics[0].values, row.dimensions[1], row.dimensions[0]])
            }
        })

    } else if(monthMetricObj.gaEcom?.reports && monthMetricObj.gaEcom?.reports[0] && monthMetricObj.gaEcom?.reports[0].rows){
        monthMetricObj.gaEcom?.reports[0].rows.forEach(row => {
            let m = ga4HeaderAsArray(row.metricValues)

            ecomMetrics.push([...m, row.dimensionValues[1].value])
            if (row.dimensionValues[0].value !== '(not set)') {
                ecomAdMetrics.push([...m, row.dimensionValues[0].value, row.dimensionValues[0].value])
            }
        })
    }

    if (monthMetricObj.gaEcom?.reports && monthMetricObj.gaEcom?.reports[1] && monthMetricObj.gaEcom?.reports[1].data && monthMetricObj.gaEcom?.reports[1].data.rows) {
        monthMetricObj.gaEcom?.reports[1].data.rows.forEach(row => {
            gaEcomDeviceMetrics.push([...row.metrics[0].values, row.dimensions[0]])
            gaEcomMedMetrics.push([...row.metrics[0].values, row.dimensions[2]])

            if (row.dimensions && row.dimensions[1] && row.dimensions[1] !== '(not set)' && row.dimensions[2] && row.dimensions[2].indexOf("cpc") !== -1){
                gaEcomCampaignMetrics.push([...row?.metrics[0].values.map(v => parseFloat(v)), row.dimensions ? row.dimensions[2] : "", row.dimensions ? row.dimensions[1] : ""])
            }

            if (row.dimensions[1] !== '(not set)') {
                if (row.dimensions[2].toLowerCase().includes('email')){
                    emailEcomMetrics.push([...row.metrics[0].values, row.dimensions[2], row.dimensions[1]])
                } else {
                    const channels = [...Object.values(socialChannels).map(s => s[0])]

                    const hasSocial = channels.reduce((prev, curr) => {
                        if(row.dimensions[2].toLowerCase().includes(curr)){
                            prev = true
                        }

                        return prev

                    }, false)
                    if(!row.dimensions[2].includes("cpc") &&
                        !hasSocial && 
                        row.dimensions[2].toLowerCase() != 'psocial' &&
                        row.dimensions[3].toLowerCase().indexOf("bing") == -1 &&
                        row.dimensions[3].toLowerCase() !== "google-my-place") {
                        otherAdsEcomMetrics.push([...row.metrics[0].values, row.dimensions[3], row.dimensions[1]])
                    }
                }
            }
        })
    } else if(monthMetricObj.gaEcom?.reports && monthMetricObj.gaEcom?.reports[1] && monthMetricObj.gaEcom?.reports[1].rows){
        monthMetricObj.gaEcom?.reports[1].rows.forEach(row => {
            let m = ga4HeaderAsArray(row.metricValues)

            gaEcomDeviceMetrics.push([...m, row.dimensionValues[0].value])
            gaEcomMedMetrics.push([...m, row.dimensionValues[2].value])

            if (row.dimensionValues && row.dimensionValues[1].value && row.dimensionValues[1].value !== '(not set)' && row.dimensionValues[2].value && row.dimensionValues[2].value.indexOf("cpc") !== -1){
                gaEcomCampaignMetrics.push([...m.map(v => parseFloat(v)), row.dimensionValues ? row.dimensionValues[2].value : "", row.dimensionValues ? row.dimensionValues[1].value : ""])
            }

            if (row.dimensionValues[1].value !== '(not set)') {
                if (row.dimensionValues[2].value.toLowerCase().includes('email')){
                    emailEcomMetrics.push([...m, row.dimensionValues[2].value, row.dimensionValues[1].value])
                } else {
                    const channels = [...Object.values(socialChannels).map(s => s[0])]

                    const hasSocial = channels.reduce((prev, curr) => {
                        if(row.dimensionValues[2].value.toLowerCase().includes(curr)){
                            prev = true
                        }

                        return prev

                    }, false)

                    if(!row.dimensionValues[2].value.includes("cpc") &&
                        !hasSocial && 
                        row.dimensionValues[2].value.toLowerCase() != 'psocial' &&
                        row.dimensionValues[3].value.toLowerCase().indexOf("bing") == -1 &&
                        row.dimensionValues[3].value.toLowerCase() !== "google-my-place") {
                        otherAdsEcomMetrics.push([...m, row.dimensionValues[3].value, row.dimensionValues[1].value])
                    }
                }
            }
        })
    }

    if(monthMetricObj.linkedin && monthMetricObj.linkedin.reports){
        if(monthMetricObj.linkedin.reports[0]){
            monthMetricObj.linkedin.reports[0].data.rows.forEach(row => {
                linkedinMetrics.push([row])
                // linkedinCampaignMetrics.push([...row, date, row.campaign.objectiveType, row.campaign.name, row.pivotValue ])   
            })
        }
    }

    perf.goals = monthMetricObj?.ga?.reports[0] ? 
        monthMetricObj?.ga?.reports[0].totals?.length > 0 ? +monthMetricObj?.ga?.reports[0].totals[0].metricValues[2].value :
        +monthMetricObj?.ga?.reports[0].data?.totals[0].values[2] : 0

    perf.gaEcomMedMetrics = sumByLastIndex(gaEcomMedMetrics)
    perf.gaEcomMedMetricDetails = perf.gaEcomMedMetrics.map(src => {

        return {
            id: src[0],
            sessions: src[1][0],
            transactions: src[1][1],
            revenue: src[1][4],
        }
    })
    perf.ecomMetricsTotal = sumArrays(perf.gaEcomMedMetrics.map(el => el[1]))

    perf.gaEcomMetricOrganicSum = perf.gaEcomMedMetricDetails.reduce((map, item) => {
        if(item.id.includes("organic")){
            map.count ++
            Object.keys(item).forEach(k => {
                if(isNumber(item[k])) {
                    map[k] += item[k]
                }
            })
        }

        return map
    }, {
        count: 0,
        sessions: 0,
        transactions: 0,
        revenue: 0
    })

    perf.ecomAdsByCompaign = sumByLastIndex(ecomAdMetrics)
    perf.ecomAdsByCompaignTotal = sumArrays(perf.ecomAdsByCompaign.map(el => el[1]))

    perf.adsByCompaign = sumByLastIndex(adMetrics)
    perf.adsByCompaignTotal = sumArrays(perf.adsByCompaign.map(el => el[1]))


    perf.gaEcomCampaignMetrics = sumByLastIndex(gaEcomCampaignMetrics)
    perf.gaEcomCampaignMetricTotals = sumArrays(perf.gaEcomCampaignMetrics.map(el => el[1]))

    perf.gaEcomCampaignMetricsByChannel = gaEcomCampaignMetrics.reduce((prev, curr, idx, arr) => {
        if(curr[curr.length - 2] === "bing / cpc") {
            prev.bingCpc.rows.push(curr)
        }

        if(arr.length - 1 === idx){
            prev.bingCpc.totals = prev.bingCpc.rows.length > 0 ? sumByLastIndex(prev.bingCpc.rows) : []
            prev.bingCpc.campaignTotals = prev.bingCpc.rows.length > 0 ? sumArrays(prev.bingCpc.totals.map(el => el[1])) : []
        }

        return prev
    }, {
        bingCpc: {
            rows: [],
            totals: [],
            campaignTotals: []
        }
    })
    // perf.ecomMetrics = sumByLastIndex(ecomMetrics)
    // perf.ecomMetricsTotal = sumArrays(perf.ecomMetrics.map(el => el[1]))

    perf.mediumMetrics = mediumMetrics
    perf.sesByMedium = sumByLastIndex(mediumMetrics).sort((a, b) => +a[1][0]>+b[1][0] ? -1 : +a[1][0] === +b[1][0] ? 0 : 1).slice(0, 5) // top 5 medium

    let smDetails = sumByLastIndex(sourceMediumMetrics)
    let smMobDetails = sumByLastIndex(mobileSourceMediumMetrics)
    let smDetailsNonCpc = sumByLastIndex(sourceMediumMetricsNonCpc)
    let smMobDetailsNonCpc = sumByLastIndex(mobileSourceMediumMetricsNonCpc)

    let emailSmDetails = sumByLastIndex(emailSrcMedMetrics)

    perf.emailSmTotals = sumArrays(emailSmDetails.map(el => el[1]))
    perf.emailCampaignTotals = perf.emailSmTotals.slice(0)

    perf.otherAdMetrics = sumByLastIndex(otherAdMetrics)
    perf.sesByOtherAdTotals = sumArrays(perf.otherAdMetrics.map(el => el[1]))
    
    const leadsBySrcMed = leadsBySrcMedHour.reduce((map, curr, idx, arr) => {
        let leads = parseInt(curr[0])

        if(map[curr[1]] === undefined ){
            map[curr[1]] = { total: 0, valueAfterHours: 0}
        }

        map[curr[1]].total += leads

        if(parseInt(curr[2]) >= 17 || parseInt(curr[2]) <= 8) {
            map[curr[1]].valueAfterHours += leads
        }

        return map
    }, {})

    perf.goalsAfterHours = Object.values(leadsBySrcMed).length > 0 ? Object.values(leadsBySrcMed).reduce((num, item) => {
        if(item.valueAfterHours > 0){
            num += item.valueAfterHours
        }

        return num
    }, 0) : 0

    perf.sesBySrcMediumDetails = smDetails.map(src => {
        let mobDetails = smMobDetails.find(srcMob => srcMob[0] === src[0]) || [0, [1, 0, 0]]
        return {
            id: src[0],
            sessions: src[1][0],
            retSess: formatPercent(src[1][0]-src[1][1], src[1][0]),
            goals: src[1][2],
            gcr: formatAverage(100*src[1][2], src[1][0])+'%',
            mobileGoals: mobDetails[1][2],
            mobileGcr: formatAverage(100*mobDetails[1][2], mobDetails[1][0])+'%',
            mobileSessions: mobDetails[1][0],
            events: src[1][3],
            bounceRate: formatPercent(src[1][4], src[1][0]),
            sesDur: formatDuration(src[1][5], src[1][0]),
            sesPgs: formatAverage(src[1][6], src[1][0]),
            goalsAfterHoursPct: leadsBySrcMed[src[0]] && src[1][2] > 0 ? (leadsBySrcMed[src[0]].valueAfterHours / src[1][2] * 100).toFixed(0) : 0,
            daily: sumByLastIndex(sourceMediumMetrics.filter(x => x.slice(-1)[0] === src[0]).map(x => [...x, x.slice(-2)[0]])).map(x => [x[0], x[1][0]]),
            // dailyLeads: sumByLastIndex(sourceMediumMetrics.filter(x => x.slice(-1)[0] === src[0]).map(x => [...x, x.slice(-2)[0]])).map(x => [x[0], x[1][2]]),
        }
    })


    perf.sesBySrcMediumDetailsNonCpc = smDetailsNonCpc.map(src => {
        let mobDetails = smMobDetailsNonCpc.find(srcMob => srcMob[0] === src[0]) || [0, [1, 0, 0]]
        return {
            id: src[0],
            sessions: src[1][0],
            retSess: formatPercent(src[1][0]-src[1][1], src[1][0]),
            goals: src[1][2],
            gcr: formatAverage(100*src[1][2], src[1][0])+'%',
            mobileGoals: mobDetails[1][2],
            mobileGcr: formatAverage(100*mobDetails[1][2], mobDetails[1][0])+'%',
            events: src[1][3],
            bounceRate: formatPercent(src[1][4], src[1][0]),
            sesDur: formatDuration(src[1][5], src[1][0]),
            sesPgs: formatAverage(src[1][6], src[1][0]),
            goalsAfterHoursPct: leadsBySrcMed[src[0]] && src[1][2] > 0 ? (leadsBySrcMed[src[0]].valueAfterHours / src[1][2] * 100).toFixed(0) : 0,
            daily: sumByLastIndex(sourceMediumMetricsNonCpc.filter(x => x.slice(-1)[0] === src[0]).map(x => [...x, x.slice(-2)[0]])).map(x => [x[0], x[1][0]]),
            dailyLeads: sumByLastIndex(sourceMediumMetricsNonCpc.filter(x => x.slice(-1)[0] === src[0]).map(x => [...x, x.slice(-2)[0]])).map(x => [x[0], x[1][2]]),
        }
    })

    perf.gmbAdMetricTotals = gmbAdMetrics.reduce((prev, curr) => {
        prev.goals += +curr[2]

        return prev
    }, {
        goals: 0
    })

    let gmbMetricObj = gmbMetrics.reduce((map, m, index, arr) => {
        m.forEach(v => {
            if(map[`${v.metric}_TOTAL`] === undefined) map[`${v.metric}_TOTAL`] = 0

            map[`${v.metric}_TOTAL`] += v.totalValue ? parseInt(v.totalValue.value) : 0
        })

        return map
    }, {})

    perf.gmbTotalQueries = gmbMetricObj["QUERIES_DIRECT_TOTAL"] ? (gmbMetricObj["QUERIES_DIRECT_TOTAL"] + gmbMetricObj["QUERIES_INDIRECT_TOTAL"]) : 0
    perf.gmbTotalActions = gmbMetricObj["ACTIONS_WEBSITE_TOTAL"] ? (gmbMetricObj["ACTIONS_PHONE_TOTAL"] + gmbMetricObj["ACTIONS_WEBSITE_TOTAL"] + gmbMetricObj["ACTIONS_DRIVING_DIRECTIONS_TOTAL"]) : 0
    perf.gmbTotalViews = gmbMetricObj["VIEWS_MAPS_TOTAL"] ? (gmbMetricObj["VIEWS_MAPS_TOTAL"] + gmbMetricObj["VIEWS_SEARCH_TOTAL"]) : 0

    perf.gbpTotalImpressions = (monthMetricObj?.gmb?.BUSINESS_IMPRESSIONS_DESKTOP_MAPS ?? 0) +
        (monthMetricObj?.gmb?.BUSINESS_IMPRESSIONS_MOBILE_MAPS ?? 0) +
        (monthMetricObj?.gmb?.BUSINESS_IMPRESSIONS_DESKTOP_SEARCH ?? 0) +
        (monthMetricObj?.gmb?.BUSINESS_IMPRESSIONS_MOBILE_SEARCH ?? 0)
    
    perf.gbpTotalActions = (monthMetricObj?.gmb?.CALL_CLICKS ?? 0) +
        (monthMetricObj?.gmb?.WEBSITE_CLICKS ?? 0) +
        (monthMetricObj?.gmb?.BUSINESS_DIRECTION_REQUESTS ?? 0)

    function isNumber (value) {
        if (typeof value !== 'number') {
          return false
        }
      
        if (value !== Number(value)) {
          return false
        }
        
        if (Number.isFinite(value) === false) {
          return false
        }
      
        return true
    }

    perf.sesBySrcMediumOrganicSum = perf.sesBySrcMediumDetails.reduce((map, item) => {
        if(item.id.includes("organic")){
            map.count ++
            Object.keys(item).forEach(k => {
                if(isNumber(item[k])) {
                    map[k] += item[k]
                }
            })
        }

        return map
    }, {
        count: 0,
        sessions: 0,
        retSess: 0,
        goals: 0,
        gcr: 0,
        mobileGoals: 0,
        mobileGcr: 0,
        events: 0,
        bounceRate: 0,
        sesDur: 0,
        sesPgs: 0,
        daily: 0,
        dailyLeads: 0,
    })

    perf.sesByDC = sumByLastIndex(deviceCategoryMetrics)
    perf.sesByDCTotals = sumArrays(perf.sesByDC.map(el => el[1]))

    perf.orgSesByDC = sumByLastIndex(orgDeviceCategoryMetrics)

    perf.orgSesByDCDetails = perf.orgSesByDC.map(src => ({
        id: src[0],
        sessions: src[1][0],
        goals: src[1][2]
    }))
    
    perf.totalSessions = perf.sesByDCTotals[0]
    perf.sesTotals = perf.sesByDCTotals.slice(0)
    
    perf.userMetricsTotals = sumByLastIndex(userTypeMetrics)
    perf.userTypeMetrics = perf.userMetricsTotals.length !== 2 ? {new: Array(7), ret: Array(7)} : 
    perf.userMetricsTotals.find(el => el[0] === 'New Visitor') && perf.userMetricsTotals.find(el => el[0] === 'Returning Visitor') ?
    {new: perf.userMetricsTotals.find(el => el[0] === 'New Visitor')[1], ret: perf.userMetricsTotals.find(el => el[0] === 'Returning Visitor')[1]} : 
    {new: Array(7), ret: Array(7)}
    
    let actions = {}

    fbMetrics.forEach(row => {
        let campaign = row[0].campaign_name
        let objective = row[0].objective

        switch (objective) {
        case 'CONVERSIONS':
            actions[campaign] = {id: 'offsite_conversion.fb_pixel_lead', name: 'Leads'}
            break
        case 'LINK_CLICKS':
            actions[campaign] = {id: 'link_click', name: 'Traffic'}
            break
        case 'LEAD_GENERATION':
            actions[campaign] = {id: 'leadgen_grouped', name: 'FB Forms'}
            break
        case 'POST_ENGAGEMENT':
            actions[campaign] = {id: 'link_click', name: 'Engagement'}
            break
        case 'OUTCOME_ENGAGEMENT':
            actions[campaign] = {id: 'link_click', name: 'Engagement'}
            break
        case 'OUTCOME_LEADS':
            actions[campaign] = {id: 'lead', name: 'Leads'}
            break
        default:
            // console.log('unknown objective: '+objective)
            actions[campaign] = {id: 'dummy', name: 'Unknown'}
            break
        }
    })
    let leadTypes = ['LEAD_GENERATION', 'CONVERSIONS', 'OUTCOME_LEADS']
    
    let get_action = (row, id, new_switch=false) => {
        let param = new_switch ? "actions" : "unique_actions"
        if (!row[param]) {
            return 0
        }
        let act = row[param].filter(x => x.action_type === id)
        return act.length ? +act[0].value : 0
    }

    let get_action_val = (row, id) => {
        if (!row.action_values) {
            return 0
        }
        let act = row.action_values.filter(x => x.action_type === id)
        return act.length ? +act[0].value : 0
    }

    let get_lead_spend = (row) => {
        let objective = row.objective
        
        return leadTypes.includes(objective) ? +row.spend : 0
    }

    let get_lead_items = (row, id) => {
        let objective = row.objective
        if (!row.unique_actions) {
            return 0
        }
        let act = row.unique_actions.filter(x => x.action_type === id)
        return leadTypes.includes(objective) && act.length ? +act[0].value : 0
    }
    perf.adsFBByCompaign = sumByLastIndex(fbMetrics.map(row => [
        get_action(row[0], 'link_click', true),
        row[0].impressions ? +row[0].impressions : 0, 
        get_action(row[0], 'link_click'),
        row[0].spend ? +row[0].spend : 0,
        0,
        get_action(row[0], actions[row[0].campaign_name].id, true) || get_action(row[0],actions[row[0].campaign_name].id),
        get_action(row[0], 'lead', true),
        get_lead_spend(row[0]),
        get_action_val(row[0], 'offsite_conversion.fb_pixel_purchase'),
        get_action(row[0], 'purchase', true),
        get_action(row[0], 'offsite_conversion.fb_pixel_lead', true),
        get_action(row[0], 'offsite_conversion.fb_pixel_purchase', true),
        row[0].campaign_name,
    ]))
      
    perf.adsFBByCompaignTop = perf.adsFBByCompaign.sort((a, b) => +a[1][0]>+b[1][0] ? -1 : +a[1][0] === +b[1][0] ? 0 : 1).slice(0, 5) // top 5 clicks
    perf.adsFBByCompaignTotal = sumArrays(perf.adsFBByCompaign.map(el => el[1]))

    perf.bingCampaignMetricsByName = sumByLastIndex(bingCampaignMetrics)
    perf.bingCampaignMetricsTotals = sumArrays(perf.bingCampaignMetricsByName.map(el => el[1]))

    perf.sourceToCampaignMap = sourceToCampaignMap

    perf.linkedInOrgStats = {
        impressions: (monthMetricObj?.linkedinOrg?.shareStats?.totalShareStatistics?.impressionCount ?? 0),
        followers: (monthMetricObj?.linkedinOrg?.followerStats?.followerGains?.organicFollowerGain ?? 0) + (monthMetric?.linkedinOrg?.followerStats?.followerGains?.paidFollowerGain ?? 0)
    }

    perf.emailEcomRevenue = 0
    perf.emailEcomTransactions = 0
    
    emailEcomMetrics.forEach(e => {
        perf.emailEcomRevenue += (+e[4])
        perf.emailEcomTransactions += (+e[1])
    })

    perf.gaOtherEcomRevenue = 0
    perf.gaOtherEcomTransactions = 0

    otherAdsEcomMetrics.forEach(vals => {
        perf.gaOtherEcomRevenue += parseFloat(vals[4])
        perf.gaOtherEcomTransactions += parseInt(vals[1])
    })

    perf.gaEcomMetricByMedium = perf.gaEcomMedMetrics.reduce((map, item) => {
        const med = item[0].split("/")[1] ? item[0].split("/")[1].trim() : ""
        if(map[med] === undefined){
            map[med] = {
                count: 0,
                sessions: 0,
                transactions: 0,
                revenue: 0,
                items: []
            }
        }

        map[med].count ++
        map[med].sessions += item[1][0]
        map[med].transactions += item[1][1]
        map[med].revenue += item[1][4]
        map[med].items.push(item)

        return map
    }, {})

    let combinedCityMetrics = cityMetrics.reduce((prev, curr, idx, arr) => {
        if(prev.all[curr[4]] === undefined){
            prev.all[curr[4]] = {}
        }

        if(prev.all[curr[4]][curr[5]] === undefined){
            prev.all[curr[4]][curr[5]] = {
                city: curr[4],
                region: curr[5],
                sessions: 0,
                goals: 0,
                transactions: 0,
                revenue: 0
            }
        }

        prev.all[curr[4]][curr[5]].sessions += parseInt(curr[0])
        prev.all[curr[4]][curr[5]].goals += parseInt(curr[1])
        prev.all[curr[4]][curr[5]].transactions += (curr[2] ? parseInt(curr[2]) : 0)
        prev.all[curr[4]][curr[5]].revenue += (curr[3] ? parseFloat(curr[3]) : 0)
        
        if(idx === arr.length -1){
            Object.keys(prev.all).forEach(k => {
                prev.all[k] = Object.values(prev.all[k])
            })

            prev.all = Object.values(prev.all)
        }

        if(curr[7] && curr[7] !== "(not set)"){
            if(prev.googlePaidAds[curr[4]] === undefined){
                prev.googlePaidAds[curr[4]] = {}
            }

            if(prev.googlePaidAds[curr[4]][curr[5]] === undefined){
                prev.googlePaidAds[curr[4]][curr[5]] = {
                    city: curr[4],
                    region: curr[5],
                    sessions: 0,
                    goals: 0,
                    transactions: 0,
                    revenue: 0
                }
            }

            prev.googlePaidAds[curr[4]][curr[5]].sessions += parseInt(curr[0])
            prev.googlePaidAds[curr[4]][curr[5]].goals += parseInt(curr[1])
            prev.googlePaidAds[curr[4]][curr[5]].transactions += (curr[2] ? parseInt(curr[2]) : 0)
            prev.googlePaidAds[curr[4]][curr[5]].revenue += (curr[3] ? parseFloat(curr[3]) : 0)
            
        }

        if(idx === arr.length -1){
            Object.keys(prev.googlePaidAds).forEach(k => {
                prev.googlePaidAds[k] = Object.values(prev.googlePaidAds[k])
            })

            prev.googlePaidAds = Object.values(prev.googlePaidAds)
        }

        return prev
    }, {
        all: {},
        googlePaidAds: {}
    })

    perf.cityMetrics = []

    if(!Array.isArray(combinedCityMetrics.all) && Object.keys(combinedCityMetrics.all).length === 0){
        combinedCityMetrics.all = []
    }

    if(!Array.isArray(combinedCityMetrics.googlePaidAds) && Object.keys(combinedCityMetrics.googlePaidAds).length === 0){
        combinedCityMetrics.googlePaidAds = []
    }

    combinedCityMetrics.all?.forEach(region => {
        region.forEach(city => {
            perf.cityMetrics.push(city)
        })
    })

    perf.bingCampaignMetricsByName = sumByLastIndex(bingCampaignMetrics)
    perf.bingCampaignMetricsTotals = sumArrays(perf.bingCampaignMetricsByName.map(el => el[1]))

    perf.linkedInGoals = 0
    perf.linkedInLeads = 0

    perf.linkedInAdSpend = 0
    perf.linkedInLeadAdSpend = 0

    perf.linkedInGoalsByDay = {}
    perf.linkedInLeadsByDay = {}
    perf.linkedInCampaigns = {}

    const linkedInLeadTypes = ['LEAD_GENERATION', 'WEBSITE_CONVERSION']

    linkedinMetrics.forEach(m => {
        perf.linkedInGoals += m[0].externalWebsiteConversions ?? 0
        perf.linkedInAdSpend += m[0].costInUsd ? parseFloat(m[0].costInUsd) : 0

        if(linkedInLeadTypes.includes(m[0].campaign?.objectiveType)){  
            perf.linkedInLeadAdSpend += m[0].costInUsd ? parseFloat(m[0].costInUsd) : 0         
            perf.linkedInLeads += m[0].externalWebsiteConversions ?? 0
        }
    })

    return {
        ...monthMetricObj,
        ...perf
    }
}
